import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

class AppointmentSuccessModalStore extends BaseModalStore {
  @observable closeCallback = noop;
  @observable type = 2; // 1-手机号预约 2-扫码预约

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.onClose();
  };

  checkAgree = () => {
    this.agree = !this.agree;
  };

  use() {
    super.use();
  }
}

export default AppointmentSuccessModalStore;
